module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sendMessage":"Send message","messageSent":"Message sent","note":"Note with a reason for rejection (visible only to you)","noteTip":"Candidate won\u0027t see this note. It will be visible only to you.","send":"Send","cancel":"Clear"}}')
  delete Component.options._Ctor
}
